export default "__VITE_ASSET__58c2e97c__"